import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { ChevronDownIcon } from 'tdesign-icons-react';
import { Avatar, Button, DialogPlugin, Dropdown, MessagePlugin } from 'tdesign-react';
import { useNavigate } from 'react-router-dom';
import { deleteToken } from '@/utils/storage';
import { doLogout as doLogoutService } from '@/services/authService';
import ChangePassword from './ChangePassword';

function UserDropdown({ info, frontConfig, thirdParty }) {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  const name = info.username || info.account;

  const options = useMemo(() => {
    if (thirdParty) {
      return [
        {
          content: '退出登录',
          value: 2,
        },
      ];
    }
    return [
      {
        content: '更换密码',
        value: 1,
      },
      {
        content: '退出登录',
        value: 2,
      },
    ];
  }, [thirdParty]);

  const doLogout = () => {
    const dialog = DialogPlugin.confirm({
      header: '提示',
      theme: 'info',
      body: '确定退出登录？',
      confirmBtn: {
        content: '退出登录',
      },
      onCancel: () => dialog.hide(),
      onCloseBtnClick: () => dialog.hide(),
      onConfirm: async () => {
        try {
          dialog.update({
            confirmBtn: {
              loading: true,
              content: '退出登录',
            },
          });
          const thirdPartyOrg = frontConfig['third-party-org'];
          const { data } = await doLogoutService(thirdPartyOrg);

          deleteToken();
          // 如果第三方登录
          if (thirdParty && data && thirdPartyOrg === 'citics') {
            const logoutUrl = new URL(data.data);
            logoutUrl.searchParams.set('redirect_uri', frontConfig['third-party']);
            location.href = logoutUrl.toString(); // 重定向
            return;
          }
          // 正常退出
          dialog.hide();
          location.href = '/login';
        } catch (error) {
          console.trace(error);
          throw error;
        } finally {
          dialog.update({
            confirmBtn: {
              loading: false,
              content: '退出登录',
            },
          });
        }
      },
    });
  };

  const handleClose = (changed) => {
    setVisible(false);
    if (changed) {
      MessagePlugin.success('修改成功，请重新登录');
      deleteToken();
      setTimeout(() => {
        navigate('/login');
      }, 300);
    }
  };

  const clickHandler = ({ value }) => {
    switch (value) {
      case 1:
        setVisible(true);
        break;

      case 2:
        doLogout();
        break;
      default:
        break;
    }
  };

  return (
    <Root>
      <Avatar style={{ width: 30, height: 30 }}>{name?.slice(0, 1).toUpperCase()}</Avatar>
      <Dropdown
        direction='right'
        hideAfterItemClick
        onClick={clickHandler}
        options={options}
        placement='bottom-left'
        trigger='hover'
      >
        <Button
          variant='text'
          theme='default'
          style={{ background: 'transparent', border: 'none' }}
          suffix={<ChevronDownIcon />}
        >
          {name}
        </Button>
      </Dropdown>
      <ChangePassword visible={visible} handleClose={handleClose} />
    </Root>
  );
}

export default connect((state) => ({
  info: state.auth.info || {},
  thirdParty: state.auth.thirdParty,
  frontConfig: state.platform.frontConfig,
}))(UserDropdown);

const Root = styled.div`
  display: flex;
  align-items: center;
`;
